import React from "react";
import { ExpenseSummary } from "../components/SpendAnalyzer";
import ExpenseTable from "../components/ExpenseTable";
import { updateExpense, deleteExpense } from "../services/api";

function getMonthName(monthNumber) {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString("en-US", {
    month: "long",
  });
}

const Expenses = ({
  month,
  year,
  account,
  setMonth,
  setYear,
  totalsByCategory,
  categories,
  expensesPaginated,
  setExpensesPaginated,
}) => {
  const handlePreviousMonth = () => {
    if (month === 1) {
      setMonth(12);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  };
  const handleNextMonth = () => {
    if (month === 12) {
      setMonth(1);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  };

  const handleSave = async (editedExpense) => {
    try {
      await updateExpense(editedExpense);
      setExpensesPaginated(
        expensesPaginated.map((expense) =>
          expense._id === editedExpense._id ? editedExpense : expense
        )
      );
    } catch (error) {
      console.error("Error updating expense:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteExpense(id, account);
      setExpensesPaginated(
        expensesPaginated.filter((expense) => expense._id !== id)
      );
    } catch (error) {
      console.error("Error deleting expense:", error);
    }
  };

  return (
    <div className="bg-slate-200 p-4 rounded-t-lg shadow-lg">
      <h3 className="text-center text-xl font-bold underline text-slate-800 mb-4">
        Expenses
      </h3>
      <h4 className="text-center text-l text-slate-700 mb-4 text-xl">
        {getMonthName(month)} {year}
      </h4>
      <div className="m-3 mx-6 grid grid-cols-2 gap-2 grid-flow-col justify-stretch text-center">
        <div
          onClick={handlePreviousMonth}
          className="rounded-xl shadow-sm cursor-pointer bg-blue-500"
        >
          <h3 className="text-white">Previous Month</h3>
        </div>

        <div
          onClick={handleNextMonth}
          className="rounded-xl shadow-sm cursor-pointer bg-blue-500"
        >
          <h3 className="text-white">Next Month</h3>
        </div>
      </div>
      <ExpenseSummary
        totalsByCategory={totalsByCategory}
        expensesPaginated={expensesPaginated}
      />
      <div className="container mx-auto px-0">
        <div>
          <ExpenseTable
            expensesPaginated={expensesPaginated}
            categories={categories}
            onSave={handleSave}
            onDelete={handleDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default Expenses;
